import { useTranslation } from 'react-i18next'
import type { DeliverySpeed } from '../../types'

interface DeliveryBadgeProps {
  speed: DeliverySpeed
}

// Five delivery windows (WEB-392, DEC-022). days_3 / week_1 are confident, fast
// values reserved for a future stock feed; weeks_2_3 / weeks_3_4 are the
// lead-time-derived windows. 'unknown' renders nothing rather than invent a
// claim. No "via supplier" framing — clean, confident values only.
const SPEED_STYLE: Record<DeliverySpeed, { icon: string; textClass: string; bgClass: string } | null> = {
  days_3:    { icon: '⚡', textClass: 'text-green-700',   bgClass: 'bg-green-50' },
  week_1:    { icon: '⚡', textClass: 'text-green-700',   bgClass: 'bg-green-50' },
  weeks_2_3: { icon: '📦', textClass: 'text-gcg-blue',    bgClass: 'bg-gcg-tint' },
  weeks_3_4: { icon: '📦', textClass: 'text-neutral-700', bgClass: 'bg-gcg-tint' },
  unknown:   null,
}

export default function DeliveryBadge({ speed }: DeliveryBadgeProps) {
  const { t } = useTranslation()
  const style = SPEED_STYLE[speed] ?? null
  if (!style) return null

  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${style.bgClass} ${style.textClass}`}>
      <span>{style.icon}</span>
      {t(`shop.delivery.${speed}`)}
    </span>
  )
}
